import { useLoaderData } from "react-router-dom";
import { Link } from "react-router-dom";

export const Navigation = () => {
  const { text } = useLoaderData();
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <Link to="" />
          <a className='navbar-brand page-scroll' href='#page-top'>
            {text.Navigation ? <img src={text.Navigation.logo} alt='logo' className='logo-img' /> : 'loading'}
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#services' className='page-scroll'>
                Our Services
              </a>
            </li>
            <li>
              <a href='#about' className='page-scroll'>
                About Us
              </a>
            </li>
            <li>
              <a href='#testimonials' className='page-scroll'>
                Testimonials
              </a>
            </li>
            <li>
              <a href='#free-estimate' className='page-scroll'>
                Free Estimate
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
